import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import { getWishlist as _getWishlist, postItem as _postItem, deleteItem as _deleteItem } from '../../../services/wishlist';
export default {
  getWishlist: function () {
    var _getWishlist2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit(types.SET_LOADING_WISHLIST, true);
              _context.next = 4;
              return _getWishlist(this);

            case 4:
              data = _context.sent;
              commit(types.SET_WISHLIST, data);
              commit(types.SET_LOADING_WISHLIST, false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getWishlist(_x) {
      return _getWishlist2.apply(this, arguments);
    }

    return getWishlist;
  }(),
  postItem: function () {
    var _postItem2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2, payload) {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              commit(types.ADD_WISHLIST_ITEM, payload);

              _postItem(this, payload).catch(function (err) {
                console.error('Wishlist add error', err);
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function postItem(_x2, _x3) {
      return _postItem2.apply(this, arguments);
    }

    return postItem;
  }(),
  deleteItem: function () {
    var _deleteItem2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, payload) {
      var commit;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              commit(types.DELETE_WISHLIST_ITEM, payload);

              _deleteItem(this, payload).catch(function (err) {
                console.error('Wishlist delete error', err);
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function deleteItem(_x4, _x5) {
      return _deleteItem2.apply(this, arguments);
    }

    return deleteItem;
  }()
};